enum ImageExtractionDialogFields {
	FORMAT = "format",
	DPI = "dpi",
	HEIGHT = "height",
	WIDTH = "width",
	JPEG_QUALITY = "jpeg_quality",
	METRICS = "metrics",
	COMPRESSION = "compression",
	MULTIPAGE = "multipage",
	PAGERANGE = 'pagerange',
	SVG_STATE_MODE = "svg_state_mode",
	SVG_PATH_DRAW_MODE = "svg_path_draw_mode"
}

export default ImageExtractionDialogFields;